type Paragraph2 = {
    fontFamily: any;
    fontWeight: any;
    fontStyle: any;
    fontSize: any;
    letterSpacing: any;
    lineHeight: any;
};

export const paragraph2: Paragraph2 = {
    'fontFamily': 'var(--plasma-typo-paragraph2-font-family, \'SB Sans Text\',sans-serif)',
    'fontWeight': 'var(--plasma-typo-paragraph2-font-weight, 600)',
    'fontStyle': 'var(--plasma-typo-paragraph2-font-style, normal)',
    'fontSize': 'var(--plasma-typo-paragraph2-font-size, 1rem)',
    'letterSpacing': 'var(--plasma-typo-paragraph2-letter-spacing, -0.0190em)',
    'lineHeight': 'var(--plasma-typo-paragraph2-line-height, 1.375rem)'
};